export default __webpack_public_path__ + "maps-examples-default-styles-960-8238ac5c6c95dfe897e408977a24fce3.png";